import React, { useContext } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import List from "./List";
import Visitor from "./Visitor";
import { VisitorsProvider } from "./VisitorsContext";
import AppContext from "AppContext";

function Visitors(props) {
    const {
        api: {
            Management: { Visitors },
        },
    } = useContext(AppContext);
    return (
        <VisitorsProvider value={Visitors}>
            <Switch>
                <Route exact path="/visitors" component={List} />
                <Route exact path="/visitors/add" render={(props) => <Visitor {...props} mode="add" title="Create Visitor" />} />
                <Route exact path="/visitors/:id" render={(props) => <Visitor {...props} mode="detail" title="Visitor" />} />
                <Route exact path="/visitors/:id/update" render={(props) => <Visitor {...props} mode="update" title="Update Visitor" />} />
            </Switch>
        </VisitorsProvider>
    );
}

export default withRouter(Visitors);
